<template>
    <div>
        <Request
                ref="request"
                root="/plugin"
                @onRequestSuccess="onRequestSuccess"
                :method="dataRequestMethod">
            <slot slot="body">
                <CForm
                        v-if="dataFormStructure.rows !== undefined"
                        ref="form"
                        @onSubmit="onSubmit"
                        :options="options"
                        :structure="dataFormStructure">
                </CForm>
                <b-alert :show="dataAlertMessage !== false" variant="danger">
                    {{dataAlertMessage}}
                </b-alert>
            </slot>
        </Request>
    </div>
</template>

<script>
    import Request from '../components/Request'
    export default {
        name: 'PluginRequest',
        components: {
            Request
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            plugin: {
                type: String,
                default: '',
                required: true
            },
            function: {
                type: String,
                default: '',
                required: true
            },
            options: {
                type: Object,
                default: function () {
                    return {
                        submit: {
                            text: 'Envoyer',
                            variant: 'success'
                        }
                    }
                }
            },
        },
        mounted() {
            this.onInit()
        },
        computed: {
            requestMethod: {
                set(value) {
                    this.dataRequestMethod = value
                },
                get() {
                    return this.dataRequestMethod
                }
            }
        },
        data: () => {
            return {
                Core: window.Core,
                dataRequestMethod: 'GET',
                dataFormStructure: [],
                dataAlertMessage: false
            }
        },
        methods: {
            onInit() {
                this.$emit('onInit', this.dataId)
                this.requestMethod = 'GET'
                this.$refs.request.addArg('plugin', this.plugin)
                this.$refs.request.addArg('pluginFunction', this.pluginFunction)
                this.$refs.request.request()
            },
            onRequestSuccess(data) {
                if (undefined !== data.formStructure) {
                    this.dataFormStructure = data.formStructure
                }
                if (this.dataRequestMethod === 'GET') {
                    this.$emit('onRequestSuccess', data)
                }
                if (this.dataRequestMethod === 'POST') {
                    this.$emit('onResponseSuccess', data)
                }
            },
            onSubmit() {
                this.$emit('onSubmit')
                this.requestMethod = 'POST'
                this.dataAlertMessage = false
                this.$refs.request.addArg('plugin', this.plugin)
                this.$refs.request.addArg('function', this.function)

                if (this.$refs.request.$refs.form !==undefined) {
                    if (!this.$refs.request.$refs.form.validate()) {
                        this.dataAlertMessage = Core.Text.format(Core.Definition.getDefinition('Vous devez compléter les champs requis du formulaire'))
                        return false
                    } else {
                        let values = this.$refs.request.$refs.form.getValues()
                        this.$refs.request.addArg('values', values)
                    }
                }

                this.$refs.request.request()
            }
        }
    }
</script>
